import { render, staticRenderFns } from "./Reprobados.vue?vue&type=template&id=69e9aa1c&"
import script from "./Reprobados.vue?vue&type=script&lang=js&"
export * from "./Reprobados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports